import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppV3 from './portfolio_v2/AppV3';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppV3 />
  </React.StrictMode>
);

reportWebVitals();
